export const EDIT_DOCTOR_FIELD_TYPES = {
	TEXT_AREA: "TEXT_AREA",
	MULTI_SELECT: "MULTI_SELECT",
	LIST: "LIST",
	KEY_VALUE: "KEY_VALUE",
	FILE_UPLOAD: "FILE_UPLOAD",
	RICH_TEXT: "RICH_TEXT",
	CUSTOM_MEDICAL_REGISTRATION: "CUSTOM_MEDICAL_REGISTRATION",
};
